import { render, staticRenderFns } from "./ModalJurisdictionSelection.vue?vue&type=template&id=37a91947&scoped=true&"
import script from "./ModalJurisdictionSelection.vue?vue&type=script&lang=js&"
export * from "./ModalJurisdictionSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModalJurisdictionSelection.vue?vue&type=style&index=0&id=37a91947&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a91947",
  null
  
)

export default component.exports